<template>
  <div>
    <a-modal
      v-model="modalVisible"
      :width="720"
      :mask-closable="false"
      :footer="null"
      @cancel="handleCancel"
    >
      <div class="modal-content">
        <slot></slot>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'CustomModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: 'Modal'
    },
    modalWidth: {
      type: String,
      default: '520px'
    },
    modalHeight: {
      type: String,
      default: 'auto'
    }
  },
  data () {
    return {
      modalVisible: false
    }
  },
  watch: {
    visible (newValue) {
      this.modalVisible = newValue
    }
  },
  methods: {
    handleOk () {
      this.$emit('ok')
    },
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>
<style scoped lang="less">
.modal-content {
  max-height: 730px;
  overflow-y: auto;
}

/deep/ .ant-modal-body {
  padding-right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomModal.vue